var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import clsx from 'clsx';
import { rem } from '../utils/Polished';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
const TagSC = styled.div `
  user-select: none;
  outline: 0;

  font-family: ${(p) => p.theme.FontFamilyBase};
  font-size: ${(p) => p.theme.SizeFontTagBase};
  line-height: ${(p) => p.theme.SizeLineHeightTagBase};
  font-weight: ${(p) => p.theme.ContentFontWeightTagBase};
  white-space: nowrap;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  ._ndsTag__icon {
    margin-right: ${rem('4px')};
    flex: none;
    fill: ${(p) => p.color};
  }

  height: ${(p) => p.theme.SizeHeightTagMedium};
  border-radius: ${(p) => p.theme.SizeBorderRadiusTagMedium};
  padding: ${rem('4px')} ${rem('8px')};

  &._ndsTag--large {
    height: ${(p) => p.theme.SizeHeightTagLarge};
    border-radius: ${(p) => p.theme.SizeBorderRadiusTagLarge};
    padding: ${rem('8px')} ${rem('12px')};
  }

  color: ${(p) => p.color};
  background-color: ${(p) => p.theme.ColorBackgroundTagOutlinedBase};
  border: ${(p) => p.theme.SizeBorderWidthDefault} solid
    ${(p) => p.color};

  &._ndsTag--contained {
    color: ${(p) => p.theme.ColorFontTagContainedBase};
    background-color: ${(p) => p.color};

    ._ndsTag__icon {
      fill: ${(p) => p.theme.ColorFontTagContainedBase};
    }
  }
`;
const Tag = (props) => {
    const { label, variant, size, icon, color, forwardedRef, className: classNameProp } = props, others = __rest(props, ["label", "variant", "size", "icon", "color", "forwardedRef", "className"]);
    const classes = clsx({ '_ndsTag--contained': variant === 'contained' }, { '_ndsTag--large': size === 'l' }, classNameProp);
    let iconComp = null;
    if (icon && React.isValidElement(icon)) {
        iconComp = React.cloneElement(icon, {
            className: clsx('_ndsTag__icon', icon.props && icon.props.className),
            size: 's'
        });
    }
    return (React.createElement(TagSC, Object.assign({ ref: forwardedRef, className: classes, color: color }, others),
        iconComp,
        React.createElement("span", { className: "_ndsTag__label" }, label)));
};
Tag.propTypes = {
    label: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
        PropTypes.string
    ]).isRequired,
    variant: PropTypes.oneOf(['outlined', 'contained']),
    size: PropTypes.oneOf(['m', 'l']),
    icon: PropTypes.element,
    color: PropTypes.string,
    className: PropTypes.string,
    forwardedRef: PropTypes.any
};
Tag.defaultProps = {
    variant: 'outlined',
    size: 'm',
    icon: undefined,
    color: '#666666',
    className: undefined,
    forwardedRef: null
};
export { Tag as TagRootComp };
export default withForwardedRef(Tag);
//# sourceMappingURL=Tag.js.map